import { Injectable } from '@angular/core';

declare function showChatNative(): any;
declare function hiddenChatNative(): any;
declare function isShowedChatNative(): any;
declare function initChatNative(): any;
@Injectable()
export class ChatService {

  initChat(): void {
    initChatNative();
  }

  showChat(): void {
    showChatNative();
  }

  hiddenChat(): void {
    hiddenChatNative();
  }

  isShowedChat(): boolean {
    return isShowedChatNative();
  }

  toggle(data: string): void {
    if (data === 'chat_toggle' && this.isShowedChat()) {
      this.hiddenChat();
    } else {
      this.showChat();
    }
  }
}
